var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContactPrimaryBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Contact",
    "data-name": "Add Contact",
    transform: "translate(0.165)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 16,
    height: 16,
    transform: "translate(-0.165)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(0.919 0.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M33.808,176v3.617m1.808-1.808H32",
    transform: "translate(-21.455 -175.448)",
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M17.162,10.081v5.507a1.574,1.574,0,0,1-1.574,1.574H4.574A1.574,1.574,0,0,1,3,15.589V4.574A1.574,1.574,0,0,1,4.574,3h8.05",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "person-outline_1_",
    "data-name": "person-outline (1)",
    transform: "translate(1.968 3.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M172.413,50.557a2.352,2.352,0,1,1-4.687,0,2.352,2.352,0,1,1,4.687,0Z",
    transform: "translate(-164.956 -48)",
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M69.111,304c-2.317,0-4.669,1.278-5.1,3.691a.447.447,0,0,0,.417.57H73.8a.447.447,0,0,0,.417-.57C73.779,305.278,71.428,304,69.111,304Z",
    transform: "translate(-63.998 -297.182)",
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContactPrimaryBtnIcon);
export default __webpack_public_path__ + "static/media/add-contact-primary-btn-icon.b80552720f01729c37c58928376f9b3f.svg";
export { ForwardRef as ReactComponent };